import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  ResponsiveContainer,
  CartesianGrid,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Legend,
  Tooltip,
  Brush
} from 'recharts';

import { getReadableName, CustomizedAxisTick } from '../../util';

import style from './index.scss';

export class BrushLineChart extends React.Component {
  static propTypes = {
    chartMeta: PropTypes.object,
    data: PropTypes.array,
    dataKey: PropTypes.string
  };

  render() {
    const { chartMeta, data, dataKey } = this.props;

    if (!chartMeta || !data || !dataKey) {
      return null;
    }

    let lineElements = [];
    const chartLength = chartMeta.names.length - 1;
    for (let i = chartLength; i >= 0; i--) {
      const name = chartMeta.names[i];

      lineElements.push(
        <Line
          type="monotone"
          key={i}
          dataKey={name}
          name={getReadableName(name)}
          stroke={chartMeta.colors[i]}
        />
      );
    }

    return (
      <div className={classnames(style.noBorderCard)}>
        <div className={classnames('row', style.cardHeaderMore)}>
          <div className="col-md-12" style={{ padding: '1px' }}>
            {' '}
          </div>
        </div>
        <div className="card-body">
          <ResponsiveContainer height={260}>
            <LineChart
              data={data}
              mmargin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
              <CartesianGrid strokeDasharray="5 5" vertical={false} />
              <XAxis
                dataKey={dataKey}
                height={60}
                tickCount={5}
                tick={<CustomizedAxisTick />}
              />
              <YAxis />
              <Legend />
              <Tooltip />
              {lineElements}
              <Brush />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}
